module.exports = __webpack_public_path__ + "img/Inflammation-BLCA_GSE171351.43f0fd57.png";